import React from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle, Check } from "lucide-react";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";

export function ConflictsModal({
  conflictsModal, setConflictsModal,
  customConflictValue, setCustomConflictValue,
  resolveConflict, applyResolvedConflicts,
}) {
  return (
    <Dialog open={conflictsModal.open} onOpenChange={(open) => !open && setConflictsModal({ open: false, conflicts: {}, resolved: {} })}>
      <DialogContent className="max-w-2xl max-h-[80vh] flex flex-col">
        <DialogHeader className="flex-shrink-0">
          <DialogTitle className="flex items-center gap-2 font-['Manrope'] text-amber-600">
            <AlertTriangle className="w-5 h-5" />
            Conflits détectés
          </DialogTitle>
          <DialogDescription>
            Plusieurs emails contiennent des valeurs différentes pour les mêmes champs.
            Cliquez sur la valeur à conserver ou saisissez une valeur personnalisée.
          </DialogDescription>
        </DialogHeader>

        <div className="py-4 space-y-4 overflow-y-auto flex-1">
          {Object.entries(conflictsModal.conflicts).map(([fieldName, conflict]) => (
            <div
              key={fieldName}
              className={`p-4 rounded-lg border-2 ${conflictsModal.resolved[fieldName] !== undefined ? 'border-green-300 bg-green-50' : 'border-amber-300 bg-amber-50'}`}
            >
              <div className="flex items-center justify-between mb-3">
                <span className="font-semibold text-zinc-800">{fieldName}</span>
                {conflictsModal.resolved[fieldName] !== undefined && (
                  <span className="text-green-600 text-sm flex items-center gap-1"><Check className="w-4 h-4" /> Résolu</span>
                )}
              </div>
              <div className="space-y-2">
                <p className="text-xs text-zinc-500 mb-2">Cliquez pour choisir :</p>
                <div className="flex flex-wrap gap-2">
                  {conflict.values.map((value, idx) => (
                    <button
                      key={idx}
                      onClick={() => resolveConflict(fieldName, value)}
                      className={`px-3 py-2 rounded-lg border text-sm transition-all ${conflictsModal.resolved[fieldName] === value ? 'bg-green-500 text-white border-green-600' : 'bg-white border-zinc-300 hover:border-orange-400 hover:bg-orange-50'}`}
                    >
                      <span className="text-xs text-zinc-400 mr-1">Email {idx + 1}:</span>
                      <span className="font-medium">{value}</span>
                    </button>
                  ))}
                </div>
                <div className="mt-3 flex gap-2">
                  <input
                    type="text"
                    placeholder="Ou saisissez une autre valeur..."
                    value={customConflictValue[fieldName] || ''}
                    onChange={(e) => setCustomConflictValue(prev => ({ ...prev, [fieldName]: e.target.value }))}
                    className="flex-1 px-3 py-2 text-sm border border-zinc-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400"
                  />
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => { if (customConflictValue[fieldName]?.trim()) resolveConflict(fieldName, customConflictValue[fieldName].trim()); }}
                    disabled={!customConflictValue[fieldName]?.trim()}
                  >
                    Utiliser
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <DialogFooter className="flex-shrink-0 border-t pt-4">
          <Button variant="outline" onClick={() => setConflictsModal({ open: false, conflicts: {}, resolved: {} })}>
            Annuler
          </Button>
          <Button
            onClick={applyResolvedConflicts}
            disabled={Object.keys(conflictsModal.conflicts).length !== Object.keys(conflictsModal.resolved).length}
            className="bg-green-500 hover:bg-green-600 text-white gap-2"
          >
            <Check className="w-4 h-4" />
            Appliquer ({Object.keys(conflictsModal.resolved).length}/{Object.keys(conflictsModal.conflicts).length})
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
